import React from 'react';

function QuillNoteHeading(props) {
    const appName = {"marginBottom":"88px","textAlign":"left"};
    const small = {"display":"block","marginTop":"0px","fontSize":"0.8em"};

    return (
        <div style={appName}>
        <h1 style={{"fontFamily":"Georgia, sans-serif","fontSize":"3.2em"}}>Quillnote</h1>
        <small style={small}>{props.subHeading}</small>
      </div>  
    )
}

export default QuillNoteHeading
